import { IntegrationStateIndicatorIconOrChip } from '@modules/integrationsV2/components/IntegrationStateIndicator';
import { SyncRounded } from '@mui/icons-material';
import { Box } from '@mui/material';

const LABEL = 'Data ingestion in progress';

interface DataIngestionInProgressIndicatorProps {
  variant: 'icon' | 'chip';
}

export const DataIngestionInProgressIndicator = ({
  variant,
}: DataIngestionInProgressIndicatorProps) => {
  return (
    <IntegrationStateIndicatorIconOrChip
      variant={variant}
      icon={<SyncRounded color="info" />}
      iconTooltipTitle={LABEL}
      chipLabel={
        <Box
          sx={{
            color: 'info.main',
          }}
        >
          {LABEL}
        </Box>
      }
    />
  );
};
